module.exports = __webpack_public_path__ + "static/media/logo.6e1a487b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 242
// module chunks = 2